import { render, staticRenderFns } from "./priceMinimal.vue?vue&type=template&id=46d88728"
import script from "./priceMinimal.vue?vue&type=script&lang=js"
export * from "./priceMinimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports